import React from "react";
import "./Hero.css";
import restaurantImage from "../assets/images/waiter-serves.webp";

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">Little Lemon</h1>
        <h2 className="hero-location">Barcelona</h2>
        <p className="hero-teaser">
          Fresh Mediterranean cuisine with a touch of heart.
        </p>

        <div id="loading-overlay" className="hidden">
          <div className="spinner"></div>
        </div>

        <button
          aria-label="Open Booking Page"
          className="hero-reserve-button"
          onClick={() => {
            const overlay = document.getElementById("loading-overlay");
            overlay.classList.remove("hidden");
            setTimeout(() => {
              document.body.classList.add("fade-out");
            }, 1500); // Spinner initially visible
            setTimeout(() => {
              window.location.href = "/reservations";
            }, 2500); // Redirect after fade-out
          }}
        >
          Reserve Table
        </button>
      </div>
      <img
        src={restaurantImage}
        alt="Little Lemon Restaurant - A waiter serves food"
        width={400}
        height={500}
        fetchPriority="high"
        decoding="async"
      />
    </section>
  );
};

export default Hero;
